/**
 * @generated SignedSource<<1c37218ddadbca28b6128992a4adf633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Chain = "AVAX" | "BASE" | "BCH" | "BSC" | "BTC" | "DOGE" | "ETH" | "GAIA" | "KUJI" | "LTC" | "NOBLE" | "OSMO" | "TERRA" | "TERRA2" | "THOR" | "TRON" | "TRON" | "XRP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RujiraQueryLoaderMainAccountFragment$data = {
  readonly address: string;
  readonly chain: Chain;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RujiraReusableQueriesBalancesFragment">;
  readonly " $fragmentType": "RujiraQueryLoaderMainAccountFragment";
};
export type RujiraQueryLoaderMainAccountFragment$key = {
  readonly " $data"?: RujiraQueryLoaderMainAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RujiraQueryLoaderMainAccountFragment">;
};

import mainAccountQuery_graphql from './mainAccountQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": mainAccountQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "RujiraQueryLoaderMainAccountFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chain",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RujiraReusableQueriesBalancesFragment"
    }
  ],
  "type": "Layer1Account",
  "abstractKey": null
};

(node as any).hash = "3eb503418f0a8a6116d7d6a47d3d146d";

export default node;
